// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__rNRrs"};